import AbstractRuleSpecification from './AbstractRuleSpecification'

export default class AbstractLogicalOperatorRuleSpecification extends AbstractRuleSpecification {
  /**
   *
   * @param rules
   */
  constructor (...rules) {
    super()

    this.rules = []
    this.rules.push(...rules)
  }
}
